import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../pages/index.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../pages/about.vue')
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('../pages/products.vue')
  },
  {
    path: '/products/:slug',
    name: 'productsBySlug',
    component: () => import('../pages/products.vue')
  },
  {
    path: '/product/:slug',
    name: 'product',
    component: () => import('../pages/product.vue')
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('../pages/services.vue')
  },
  {
    path: '/service/:slug',
    name: 'service',
    component: () => import('../pages/service.vue')
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('../pages/projects.vue')
  },
  {
    path: '/project/:slug',
    name: 'project',
    component: () => import('../pages/project.vue')
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('../pages/contacts.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../pages/news.vue')
  },
  {
    path: '/news/:slug',
    name: 'newsDetail',
    component: () => import('../pages/newsDetail.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve) => {
        const findEl = (hash, attempt = 0) => {
          const el = document.querySelector(hash);
          if (el) {
            resolve({ el, behavior: 'smooth' });
          } else if (attempt < 50) {
            setTimeout(() => findEl(hash, attempt + 1), 20);
          } else {
            resolve({ top: 0, behavior: 'smooth' });
          }
        };
        findEl(to.hash);
      });
    }


    return { top: 0, behavior: 'smooth' };
  },
});


router.afterEach((to) => {
  if (!to.hash) {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });


    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, 500);
  }
});

export default router
